export default __webpack_public_path__ + "static/media/drogaria_venancio.a6e31489.png";